import React from 'react';
import { Language } from '../types/language';

interface LanguageToggleProps {
  language: Language;
  onToggle: () => void;
}

export const LanguageToggle: React.FC<LanguageToggleProps> = ({ language, onToggle }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="flex items-center gap-1.5 px-2.5 py-2 border border-ir-border bg-ir-bg text-xs font-mono uppercase tracking-wider text-ir-muted hover:text-ir-text hover:border-ir-blue/40 transition-colors duration-100 rounded-none"
      title={language === 'en' ? 'Switch to Farsi' : 'تغییر به انگلیسی'}
      aria-label={language === 'en' ? 'Switch to Farsi' : 'تغییر به انگلیسی'}
    >
      <span className={language === 'en' ? 'text-ir-text' : 'text-ir-faint'}>FA</span>
      <span className="text-ir-border">|</span>
      <span className={language === 'fa' ? 'text-ir-text' : 'text-ir-faint'}>EN</span>
    </button>
  );
};